import { render, staticRenderFns } from "./presentations.datagrid.vue?vue&type=template&id=3f6f4ab4&scoped=true&"
import script from "./presentations.datagrid.vue?vue&type=script&lang=js&"
export * from "./presentations.datagrid.vue?vue&type=script&lang=js&"
import style0 from "./presentations.datagrid.vue?vue&type=style&index=0&id=3f6f4ab4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6f4ab4",
  null
  
)

export default component.exports